var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "ItpWidgetCard",
        [
          _c(
            "ItpBox",
            { attrs: { slot: "header", alignItems: "center" }, slot: "header" },
            [
              _c("strong", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("pgettext")("Services and Fees", "Contract")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              !_vm.readonly
                ? _c("ItpButton", {
                    staticClass: "ml-auto",
                    attrs: {
                      text: _vm._f("gettext")("Add service..."),
                      variant: "light",
                      size: "sm"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_8320016629450276_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "BListGroup",
            [
              !_vm.contract.services || !_vm.contract.services.length
                ? _c(
                    "BListGroupItem",
                    [
                      _c("ItpText", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("pgettext")(
                                "No services have been added yet.",
                                "Contract"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filterItems(_vm.contract.services), function(service) {
                return _c(
                  "BListGroupItem",
                  { key: service.id },
                  [
                    _c(
                      "ItpBox",
                      { attrs: { alignItems: "center" } },
                      [
                        _c("UcContractServiceCard", {
                          style: _vm.b_5917154787680107_style,
                          attrs: { item: service }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "ml-auto mb-auto",
                            attrs: {
                              size: "sm",
                              "toggle-class": "btn-default-borderless",
                              "no-caret": "",
                              variant: "none"
                            }
                          },
                          [
                            _c("ItpIcon", {
                              staticClass: "mx-1",
                              attrs: {
                                slot: "button-content",
                                fa: "ellipsis-v"
                              },
                              slot: "button-content"
                            }),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item-button",
                              {
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.evh_294572930540096_clickPreventStop(
                                      $event,
                                      { service: service }
                                    )
                                  }
                                }
                              },
                              [
                                _c("ItpText", {
                                  attrs: {
                                    text: _vm._f("pgettext")("Edit", "Command")
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("UcContractServiceFees", {
                      attrs: {
                        contract: _vm.contract,
                        service: service,
                        reload: _vm.lastLoaded,
                        readonly: _vm.readonly
                      },
                      on: {
                        reload: function($event) {
                          return _vm.evh_6027561141562583_reload($event, {
                            service: service
                          })
                        }
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }